
// @ts-nocheck
import locale_en_46json_52c94eeb from "#nuxt-i18n/52c94eeb";
import locale_nl_46json_911e74b4 from "#nuxt-i18n/911e74b4";

export const localeCodes =  [
  "en",
  "nl"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_52c94eeb",
      load: () => Promise.resolve(locale_en_46json_52c94eeb),
      cache: true
    }
  ],
  nl: [
    {
      key: "locale_nl_46json_911e74b4",
      load: () => Promise.resolve(locale_nl_46json_911e74b4),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      language: "en-US",
      _hreflang: "en-US",
      _sitemap: "en-US",
      files: [
        {
          path: "/usr/src/app/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "nl",
      language: "nl-NL",
      _hreflang: "nl-NL",
      _sitemap: "nl-NL",
      files: [
        {
          path: "/usr/src/app/locales/nl.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "../locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "https://silvabird.com",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    language: "en-US",
    _hreflang: "en-US",
    _sitemap: "en-US",
    files: [
      {
        path: "/usr/src/app/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "nl",
    language: "nl-NL",
    _hreflang: "nl-NL",
    _sitemap: "nl-NL",
    files: [
      {
        path: "/usr/src/app/locales/nl.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = true
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/